module.exports = __webpack_public_path__ + "static/media/undraw_buy_house_560d.8c1f6fbb.svg";